import React from 'react';
import styled from 'styled-components/macro';
import OutsideClickHandler from 'react-outside-click-handler';

const ClickableDivNoProps = ({ clickable, ...props }) => <div role={clickable && 'button'} {...props} />;
const ClickableDivStyled = styled(ClickableDivNoProps)`
  ${({ clickable }) => {
    if (clickable) {
      return 'cursor: pointer';
    }
    return 'cursor: default';
  }}
`;
export default class ClickableDiv extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const { onClick, clickable } = this.props;
    if (onClick && clickable) {
      onClick();
    }
    return false;
  }

  render() {
    const {
      children,
      clickable,
      onOutsideClick,
      ...props
    } = this.props;
    const innerChildren = (
      <ClickableDivStyled onClick={this.onClick} clickable={clickable} {...props}>
        {children}
      </ClickableDivStyled>
    );
    if (onOutsideClick && clickable) {
      return (
        <OutsideClickHandler onOutsideClick={onOutsideClick}>
          {innerChildren}
        </OutsideClickHandler>
      );
    }
    return innerChildren;
  }
}
